export default "__VITE_ASSET__ng1jbBg6__"